import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import {
  CreateNotePayload,
  DeleteLotPayload,
  DeleteNotePayload,
  EditNotePayload,
  Lot,
  Movement,
  Note,
} from './lots.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/lots');

export const getLots = actionCreator.async<{}, Lot[]>('GET_LOTS');
export const getLotById = actionCreator.async<{ id: string; includeCosts: boolean }, Lot>('GET_LOT_BY_ID');
export const createLot = actionCreator.async<FormName, Lot>('CREATE_LOT');
export const updateLot = actionCreator.async<{ id: string; formName: FormName }, Lot>('UPDATE_LOT');
export const addTransfers = actionCreator.async<FormName, void>('ADD_TRANSFERS');
export const addCloseouts = actionCreator.async<FormName, void>('ADD_CLOSEOUTS');
export const addNote = actionCreator.async<CreateNotePayload, Note>('ADD_NOTE');
export const deleteNote = actionCreator.async<DeleteNotePayload, void>('DELETE_NOTE');
export const editNote = actionCreator.async<EditNotePayload, Note>('EDIT_NOTE');
export const updateLotMovements = actionCreator.async<{ id: string; movements: Movement[]; formName: FormName }, Lot>(
  'UPDATE_LOT_MOVEMENTS',
);
export const editAdditionalCostsInLot = actionCreator.async<{}, Lot>('EDIT_ADDITIONAL_COSTS_IN_LOT');
export const deleteLot = actionCreator.async<DeleteLotPayload, void>('DELETE_LOT');
